var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.state.ERROR
        ? _vm._t(
            "error",
            [
              _c("ProfileVideosEmptyState", {
                attrs: {
                  options: {
                    icon: "md:block",
                    title:
                      _vm.error === "error"
                        ? _vm.$t("fallback.unknown.title")
                        : _vm.error,
                    message:
                      _vm.error === "error"
                        ? _vm.$t("fallback.unknown.message")
                        : ""
                  }
                }
              })
            ],
            { error: _vm.error }
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.state.EMPTY
        ? _vm._t(
            "default",
            [
              _c("CardRow", {
                staticClass: "justify-content-left",
                attrs: {
                  items: _vm.content,
                  transformer: _vm.cardRowOptions.transformer,
                  actions: _vm.cardRowOptions.actions,
                  "item-type": "video"
                }
              })
            ],
            { response: _vm.response, content: _vm.content }
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.state.EMPTY && !_vm.state.LOADING && !_vm.state.ERROR
        ? _vm._t("empty", [_c("ProfileVideosEmptyState")])
        : _vm._e(),
      _vm._v(" "),
      _vm.state.LOADING
        ? _vm._t("loading", [
            _c(
              "div",
              {
                ref: "seeMoreElement",
                staticClass:
                  "\n        loader__see-more\n        row justify-content-center align-items-center\n      "
              },
              [_c("BrowseLoading", { attrs: { loading: true } })],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMorePages
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "VsButton",
                {
                  staticClass: "btn--outline--dark",
                  attrs: { loading: _vm.state.LOADING },
                  on: {
                    click: _vm.profileVideoLoadingMixin_runLoadVideoSequence
                  }
                },
                [_vm._v("\n      Load more\n    ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }